<template>
<div class="chapter">
<div class="inner_page">
<h2 class="halftitle">What’s Wrong with My Child?</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?75fef579